/*
 * Embroidery options (snippets/product-embroidery.liquid), replacing the Easify Product Options app.
 * The choices themselves are edited in Admin > Content > Metaobjects > Embroidery options.
 *
 * When "Add embroidery" is ticked, Add to cart is handled here instead of by the theme:
 *   1. the garment is added with the embroidery properties and the Easify-style link
 *      (_tpo_add_on_keys = '["<uuid>"]', _tpo_add_on_variant_ids, _tpo_is_main_product = "1");
 *   2. the embroidery fee (plus the fee of any filled-in text line that has one) is added as its
 *      own line (_tpo_add_on_key = "<uuid>"), same quantity;
 *   3. the theme cart drawer is refreshed and opened (window.cart is the theme's CartDrawer).
 * If the fee can't be added, the garment line is removed again so the cart never holds
 * embroidery details without the fee. assets/easify-cart-sync.js keeps the fee quantity in step
 * with the garment afterwards. Without embroidery, the theme's own Add to cart runs unchanged.
 */
(function () {
  'use strict';

  if (window.productEmbroideryLoaded) return;
  window.productEmbroideryLoaded = true;

  var fontsRequested = {};

  function loadFonts(url) {
    if (!url || fontsRequested[url]) return;
    fontsRequested[url] = true;
    var link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = url;
    document.head.appendChild(link);
  }

  function uuid() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') return window.crypto.randomUUID();
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = (Math.random() * 16) | 0;
      return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
    });
  }

  function isOn(root) {
    var toggle = root.querySelector('[data-embroidery-toggle]');
    return Boolean(toggle && toggle.checked);
  }

  function setOpen(root, open) {
    root.querySelector('[data-embroidery-fields]').hidden = !open;
    root.querySelectorAll('[data-embroidery-field]').forEach(function (field) {
      field.disabled = !open;
    });
    if (open) {
      loadFonts(root.getAttribute('data-fonts-url'));
    } else {
      clearErrors(root);
    }
  }

  function applyFont(root) {
    var font = root.querySelector('[data-embroidery-font]:checked');
    root.querySelectorAll('[data-embroidery-text]').forEach(function (input) {
      input.style.fontFamily = font ? "'" + font.value + "', sans-serif" : '';
    });
  }

  function showError(holder, show) {
    var field = holder.closest('.embroidery__field') || holder;
    var error = field.querySelector('[data-embroidery-error]');
    if (error) error.hidden = !show;
    if (holder.matches('input, textarea')) holder.setAttribute('aria-invalid', show ? 'true' : 'false');
  }

  function clearErrors(root) {
    root.querySelectorAll('[data-embroidery-required]').forEach(function (holder) {
      showError(holder, false);
    });
  }

  function validate(root) {
    var firstInvalid = null;
    root.querySelectorAll('[data-embroidery-required]').forEach(function (holder) {
      var valid =
        holder.getAttribute('data-embroidery-required') === 'radio'
          ? holder.querySelector('input:checked') !== null
          : holder.value.trim() !== '';
      showError(holder, !valid);
      if (!valid && !firstInvalid) firstInvalid = holder;
    });
    if (firstInvalid) {
      firstInvalid.scrollIntoView({behavior: 'smooth', block: 'center'});
      var focusTarget = firstInvalid.matches('input') ? firstInvalid : firstInvalid.querySelector('input');
      if (focusTarget) focusTarget.focus({preventScroll: true});
    }
    return !firstInvalid;
  }

  function init(root) {
    if (root.hasAttribute('data-embroidery-ready')) return;
    root.setAttribute('data-embroidery-ready', '');

    var toggle = root.querySelector('[data-embroidery-toggle]');
    toggle.addEventListener('change', function () {
      setOpen(root, toggle.checked);
    });
    // The browser can restore the ticked box on back/forward navigation.
    setOpen(root, toggle.checked);
    applyFont(root);

    root.addEventListener('change', function (event) {
      var target = event.target;
      if (target.matches('[data-embroidery-font]')) applyFont(root);
      if (target.matches('[data-embroidery-colour]')) {
        var selected = root.querySelector('[data-embroidery-selected]');
        if (selected) selected.textContent = '(' + target.getAttribute('data-embroidery-colour') + ')';
      }
      var required = target.closest('[data-embroidery-required]');
      if (required) showError(required, false);
    });

    root.addEventListener('input', function (event) {
      var target = event.target;
      if (target.matches('[data-embroidery-required="text"]') && target.value.trim() !== '') showError(target, false);
      if (target.hasAttribute('data-embroidery-count')) {
        var count = target.closest('.embroidery__field').querySelector('[data-embroidery-count-value]');
        if (count) count.textContent = target.value.length;
      }
    });
  }

  function cartAddUrl() {
    return (window.theme && window.theme.routes && window.theme.routes.cart_add_url) || '/cart/add';
  }

  function cartUrl() {
    return (window.theme && window.theme.routes && window.theme.routes.cart_url) || '/cart';
  }

  function cartUpdateUrl() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root + 'cart/update.js';
  }

  function postForm(data) {
    return fetch(cartAddUrl(), {
      method: 'POST',
      credentials: 'same-origin',
      headers: {'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript'},
      body: data,
    }).then(function (response) {
      return response.json();
    });
  }

  function postJson(url, body) {
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {'Content-Type': 'application/json', Accept: 'application/json'},
      body: JSON.stringify(body),
    }).then(function (response) {
      return response.json();
    });
  }

  // The fees to add with this garment: the embroidery fee, plus the fee of each filled-in text line
  // that has one. Each gets its own key linking it to the garment.
  function collectFees(root) {
    var fees = [{variantId: root.getAttribute('data-fee-variant-id'), ref: root.getAttribute('data-fee-ref')}];
    root.querySelectorAll('[data-embroidery-text][data-fee-variant-id]').forEach(function (input) {
      if (input.value.trim() === '') return;
      fees.push({variantId: input.getAttribute('data-fee-variant-id'), ref: input.getAttribute('data-fee-ref')});
    });
    fees.forEach(function (fee) {
      fee.key = uuid();
    });
    return fees;
  }

  // Builds the garment's form data with the embroidery link. Empty optional fields are sent blank,
  // as Easify did.
  function garmentData(form, root, fees) {
    var meta = {
      keys: JSON.stringify(fees.map(function (fee) { return fee.key; })),
      variant_ids: JSON.stringify(fees.map(function (fee) { return String(fee.variantId); })),
      main: '1',
    };
    var metaInputs = root.querySelectorAll('[data-embroidery-meta]');

    metaInputs.forEach(function (input) {
      input.value = meta[input.getAttribute('data-embroidery-meta')];
      input.disabled = false;
    });

    var data = new FormData(form);

    metaInputs.forEach(function (input) {
      input.disabled = true;
    });
    return data;
  }

  // Takes the garment and any of its fees back out of the cart.
  function removeLines(garmentKey, fees) {
    var keys = fees.map(function (fee) { return fee.key; });
    return fetch(cartUrl() + '.js', {credentials: 'same-origin', headers: {Accept: 'application/json'}})
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        var updates = {};
        cart.items.forEach(function (item) {
          var key = (item.properties || {})._tpo_add_on_key;
          if (item.key === garmentKey || (key && keys.indexOf(key) !== -1)) updates[item.key] = 0;
        });
        return postJson(cartUpdateUrl(), {updates: updates});
      });
  }

  function addWithEmbroidery(button, form, root) {
    var cart = window.cart;
    var fees = collectFees(root);
    var variantInput = form.querySelector('[name="id"]');
    var quantityInput = form.querySelector('[name="quantity"]');
    var quantity = Math.max(parseInt(quantityInput && quantityInput.value, 10) || 1, 1);
    var data = garmentData(form, root, fees);
    var errorText = root.getAttribute('data-error-text');

    if (cart) {
      cart.button = button;
      cart.form = form;
    }
    button.classList.add('is-loading');
    button.setAttribute('disabled', 'disabled');

    postForm(data)
      .then(function (garment) {
        if (garment.status) throw {response: garment};

        var mainId = String(variantInput ? variantInput.value : garment.variant_id);
        return postJson(cartAddUrl() + '.js', {
          items: fees.map(function (fee) {
            return {
              id: Number(fee.variantId),
              quantity: garment.quantity || quantity,
              properties: {_tpo_main_product_id: mainId, _tpo_add_on_key: fee.key, _tpo_option_value_id: fee.ref || ''},
            };
          }),
        }).then(function (response) {
          if (!response.status) return;
          // A fee was refused (e.g. unavailable): take the garment back out, then report.
          return removeLines(garment.key, fees).then(function () {
            throw {response: {status: response.status, message: errorText, description: errorText}};
          });
        });
      })
      .then(function () {
        document.dispatchEvent(new CustomEvent('theme:cart:add', {bubbles: true, detail: {selector: button}}));

        if (cart && cart.cartDrawerEnabled) {
          cart.hideAddToCartErrorMessage();
          cart.addLoadingClass();
          cart.getCart();
        } else {
          window.location = cartUrl();
        }
      })
      .catch(function (error) {
        var response = (error && error.response) || {message: errorText, description: errorText};
        if (cart && typeof cart.addToCartError === 'function') {
          cart.addToCartError(response);
        } else {
          button.classList.remove('is-loading');
          button.removeAttribute('disabled');
          window.alert(response.description || response.message);
        }
      });
  }

  // The Vitals sticky Add to cart bar posts the product form by itself, which would skip the check
  // and the embroidery fee. While embroidery is ticked, its button goes through the form's own
  // Add to cart button instead (with the size picked in the bar).
  function stickyAddToCart(event, sticky) {
    var root = Array.prototype.filter.call(document.querySelectorAll('form [data-embroidery]'), isOn)[0];
    if (!root) return;
    var form = root.closest('form');
    var button = form.querySelector('[data-add-to-cart]');
    if (!button) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    var bar = sticky.closest('.Vtl-StickyAddToCart');
    var picked = bar && bar.querySelector('[data-selected-value]');
    var pickedId = picked && picked.getAttribute('data-selected-value');
    var variantInput = form.querySelector('[name="id"]');
    if (variantInput && /^\d+$/.test(pickedId || '')) variantInput.value = pickedId;

    button.click();
  }

  // Capture phase on window: runs before the theme's and Vitals' Add to cart click handlers.
  window.addEventListener(
    'click',
    function (event) {
      var sticky = event.target.closest && event.target.closest('#bundle-sticky_submit, .Vtl-StickyAddToCart__AddToCartButton');
      if (sticky) {
        stickyAddToCart(event, sticky);
        return;
      }

      var button = event.target.closest && event.target.closest('[data-add-to-cart]');
      if (!button) return;
      var form = button.closest('form');
      var root = form && form.querySelector('[data-embroidery]');
      if (!root || !isOn(root) || button.hasAttribute('disabled')) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      if (validate(root)) addWithEmbroidery(button, form, root);
    },
    true
  );

  function initAll() {
    document.querySelectorAll('[data-embroidery]').forEach(init);
  }

  initAll();
  document.addEventListener('shopify:section:load', initAll);
  // assets/colour-switch.js swaps the product section when a shopper picks another colour.
  document.addEventListener('joiia:colour:switched', initAll);
})();
